import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    console.log('🔐 AuthContext: Checking authentication...');
    // Check local storage for user data
    const token = localStorage.getItem('token');
    const storedUser = {
      name: localStorage.getItem('username'),
      role: localStorage.getItem('role'),
    };

    console.log('🔐 AuthContext: Stored data:', {
      hasToken: !!token,
      username: storedUser.name,
      role: storedUser.role
    });

    if (token && storedUser.name && storedUser.role) {
      console.log('🔐 AuthContext: User authenticated, setting user data');
      setUser(storedUser);
    } else {
      console.log('🔐 AuthContext: Missing auth data, clearing and redirecting to login');
      // If any required auth data is missing, clear everything
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('role');
      setUser(null);
      navigate('/login');
    }
    setLoading(false);
  }, [navigate]);

  const login = async (username, role, token) => {
    console.log('🔐 AuthContext: Login called with:', { username, role });
    const userData = {
      name: username,
      role: role,
    };
    localStorage.setItem('token', token);
    localStorage.setItem('username', username);
    localStorage.setItem('role', role);
    setUser(userData);
  };

  const logout = async () => {
    console.log('🔐 AuthContext: Logout called');
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('role');
    setUser(null);
    navigate('/login');
  };

  const value = {
    user,
    login,
    logout,
    loading
  };

  console.log('🔐 AuthContext: Rendering with user:', user);

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}; 